import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Meta } from 'src/app/_models/meta';
import { MapaCurricularService } from '../mapa-curricular/_services/mapa-curricular.service';
import { flatMap, shareReplay, tap, catchError } from 'rxjs/operators';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-mapa-metas',
  standalone: false,
  templateUrl: './mapa-metas.component.html',
  styleUrls: ['./mapa-metas.component.scss']
})
export class MapaMetasComponent implements OnInit {

  categorias: any[];
  materias: any[];
  grados: any[];
  ambitos: any[];
  tags: any[];
  tipoId = -1;
  currentMaterias;
  currentCursos;

  form: UntypedFormGroup;

  metasAImportar: Array<Meta> = new Array<Meta>();

  categoriaActual: string;

  private metasSubject = new Subject<Observable<Meta[]>>();
  metas$: Observable<Meta[]> = this.metasSubject.asObservable().pipe(
    flatMap(data => {
      return data;
    }),
    shareReplay(1)
  );

  private guardandoSubject = new BehaviorSubject<boolean>(false);
  guardando$ = this.guardandoSubject.asObservable().pipe(shareReplay(1));

  private viewSubject = new BehaviorSubject('busqueda');
  view$ = this.viewSubject.asObservable();

  constructor(public dialogRef: MatDialogRef<MapaMetasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private mapaCurricularService: MapaCurricularService,
    private customAlert: CustomAlertService,
    private globalService: GlobalService) { }

  ngOnInit(): void {
    this.categorias = this.data.categorias;
    this.materias = this.data.materias;
    this.grados = this.data.grados;
    this.ambitos = this.data.ambitos;
    this.tags = this.data.tags;
    this.tipoId = this.data.tipoId;
    this.currentMaterias = this.data.currentMaterias;
    this.currentCursos = this.data.currentCursos;
    this.categoriaActual = this.categorias.find(item => item.ordenAgrupador === this.tipoId).nombre;


    this.form = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      text: new UntypedFormControl(''),
      categorias: new UntypedFormControl({value: this.tipoId === -1 ? [] : [this.tipoId], disabled: this.tipoId !== -1}),
      materias: new UntypedFormControl([]),
      grados: new UntypedFormControl([]),
      ambitos: new UntypedFormControl([]),
      tags: new UntypedFormControl([]),
      subCategorias: new UntypedFormControl([]),
    });
  }

  buscar() {
    const value = this.form.getRawValue();
    this.guardandoSubject.next(true);
    this.metasSubject.next(this.mapaCurricularService.buscarMetas(
      value.id === '' ? 0 : value.id,
      value.text || '""',
      value.categorias.length > 0 ? value.categorias.join() : null,
      value.materias.length > 0 ? value.materias.join() : null,
      value.grados.length > 0 ? value.grados.join() : null,
      value.ambitos.length > 0 ? value.ambitos.join() : null,
      value.tags.length > 0 ? value.tags.join() : null
    ).pipe(
      tap(data => {
        this.guardandoSubject.next(false);
      }),
      catchError((err, data) => {
        this.guardandoSubject.next(false);
        this.customAlert.setCustomMessage({
          tipo: 'error',
          texto: `Error al importar las metas. ${err.error} <br> Código de error: ${err.statusText}`
        });
        return data;
      })
    ));
  }

  cerrar() {
    this.dialogRef.close();
  }

  importar() {
    this.metasAImportar.forEach(meta => {
      meta.materias = this.globalService.unionArrays(meta.materias, this.currentMaterias);
      meta.cursos = this.globalService.unionArrays(meta.cursos, this.currentCursos);
    });
    this.guardandoSubject.next(true);
    this.mapaCurricularService.importarMetas(this.metasAImportar).subscribe(
      res => {
        this.guardandoSubject.next(false);
        this.customAlert.setCustomMessage({
          tipo: 'success',
          texto: `Se han agregado las metas seleccionadas al mapping actual.`
        });
        this.dialogRef.close();
      },
      err => {
        this.guardandoSubject.next(false);
        this.customAlert.setCustomMessage({
          tipo: 'error',
          texto: `Error al importar las metas. ${err.error} <br> Código de error: ${err.statusText}`
        });
      }
    );
  }

}
